// extracted by mini-css-extract-plugin
export default {"link":"Logo_link__34WqR"};